import { gql } from '@apollo/client'

export default gql(`
    mutation batchEditConfigInstance($input: [editConfigInstanceInput] $project: String $app: ID! $appConfigId: ID!) {
        batchEditConfigInstance(
          input: $input
          project: $project
          app: $app
          appConfigId: $appConfigId
        ) {
          id
          fieldValues {
            configField {
              id
              name
              type
              isRequired
              project
              useAsTitle
              tooltipText
            }
            value
            bucket {
              project
              id
              isArchived
              name
              isPublished
              publishStartDate
              publishEndDate
              updatedAt
              updatedBy
              key
              displayName
              displayType{
                name
                id
              }
            }
            image {
              id
              
              fileName
              aspectRatio {
                  aspectRatio
                  ratio
                  title          
                  resolutions {
                    url
                  }
              }
              settings {
                  aspectRatio
                  outputFormat
                  fileName
                  x1
                  y1
                  x2
                  y2          
              }
          }
            project
            position
          }
          isEnabled
          position
          project
          appConfigId
          createdAt
          createdBy
        }
    }`
)
